const IS_DEV_MODE = process.env.REACT_APP_COMPANY_KEY === 'dev';
const ITS_WITH_ITALIAN = Boolean(Number(process.env.REACT_APP_ITALIANO));
const ITS_WITH_CZECH = Boolean(Number(process.env.REACT_APP_CZECH));
const ITS_WITH_JAPANESE = Boolean(Number(process.env.REACT_APP_JAPANESE));
const ITS_WITH_PORTUGUESE = Boolean(Number(process.env.REACT_APP_PORTUGUESE));
const ITS_WITH_TURKISH = Boolean(Number(process.env.REACT_APP_TURKISH));
const ITS_WITH_ROMANIAN = Boolean(Number(process.env.REACT_APP_ROMANIAN));
const ITS_WITH_DEUTSCH = Boolean(Number(process.env.REACT_APP_DEUTSCH));
const ITS_WITH_KOREAN = Boolean(Number(process.env.REACT_APP_KOREAN));

export interface BrandConfig {
  brandName: string;
  isNewCRM: boolean;
  apiUrl: string;
  hasChat?: boolean;
  languages: { [lang: string]: boolean };
  authTranslatesKeys?: {
    signIn: string;
    signUp: string;
  };
}

let config: BrandConfig | null = null;
let isLoading = false;

// загружаем конфиг с сервера
export const loadConfig = async (): Promise<void> => {
  if (config || isLoading) return;

  isLoading = true;

  try {
    const response = await fetch('/config.json');

    if (!response.ok) {
      throw new Error(`Failed to load config: ${response.statusText}`);
    }

    config = await response.json();

    if (!config) {
      throw new Error('Config not found');
    }

    document.title = config.brandName;
  } catch (error) {
    console.error('Error loading config:', error);
  } finally {
    isLoading = false;
  }
};

export const getConfigValue = <K extends keyof BrandConfig>(key: K): BrandConfig[K] | null => {
  return config?.[key] ?? null;
};

// геттеры
export const isNewCRM = () => getConfigValue('isNewCRM');
export const getBrand = () => getConfigValue('brandName');
export const getApiUrl = () => {
  const url = getConfigValue('apiUrl');
  return `https://${url}`;
};
export const getLanguages = () => getConfigValue('languages');
export const getAuthTranslatesKeys = () => getConfigValue('authTranslatesKeys');

export const hasChat = () =>
  getConfigValue('hasChat') || process.env.REACT_APP_CHAT_ENABLED === 'true';

export const isConfigLoaded = () => config !== null;

export {
  IS_DEV_MODE,
  ITS_WITH_ITALIAN,
  ITS_WITH_CZECH,
  ITS_WITH_JAPANESE,
  ITS_WITH_PORTUGUESE,
  ITS_WITH_TURKISH,
  ITS_WITH_ROMANIAN,
  ITS_WITH_DEUTSCH,
  ITS_WITH_KOREAN,
};
